export default "__VITE_ASSET__Csj5wyPK__"